import React, { useEffect } from 'react'
import Modal from '../Modal'
import DiscountBody from './DiscountBody'
import { useTheme } from '../ThemeProvider/ThemeProvider'
import styles from './DiscountModal.module.scss'

const DiscountPlanModal = () => {
  const { themeMode } = useTheme() || {}

  /* const showFirstTime = () => {
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      const discountModalShown = localStorage.getItem('discountModalShown')
      if (!discountModalShown) {
        show('claimDiscount')
      }
    }, 1000)
  } */

  useEffect(() => {
    // showFirstTime()
  }, [])

  return (
    <Modal
      className={styles.modal}
      id='claimDiscount'
      themeMode={themeMode}
      modalCoverStyle={{ zIndex: 9999 }}
      hasCloseButton={false}
      shouldCloseOnOverlayClick
      onClose={() => {
        // eslint-disable-next-line no-undef
        localStorage.setItem('discountModalShown', true)
      }}
      bodyStyle={{ margin: '0' }}
    >
      {({ modalData }) => {
        return (
          <DiscountBody type={modalData} />
        )
      }}
    </Modal>
  )
}

export default DiscountPlanModal
